// extracted by mini-css-extract-plugin
module.exports = {"testimonialBox":"TestimonialBox_testimonialBox__V_jiZ","name":"TestimonialBox_name__zC_jQ","content":"TestimonialBox_content___jIy1"};